export class LoginError extends Error {
    constructor(error, data = undefined) {
        super(error);
        if (data) {
            Object.assign(this, data);
        }
    }
}
//# sourceMappingURL=LoginError.js.map